import React, { useEffect, useState, useRef } from 'react';
// import { useHistory } from 'react-router-dom';
import { withRouter } from 'react-router-dom'; // To access history in v4
import AWS from 'aws-sdk';
import { device as awsIot } from 'aws-iot-device-sdk';

const FuelSensorData = ({ onVoltageChange, topic, isSensorListening, toggleReciveSensorData, dataField = 9 }) => {
  const [mqttClient, setMqttClient] = useState(null);
  const [credentials, setCredentials] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (isSensorListening && !mqttClient && !isConnected && !credentials) {
      // AWS Cognito Identity Pool ID
      const identityPoolId = 'ap-south-1:f2dbf591-e7dd-4e39-9d61-fc3d8c292a29'; // Replace with your Cognito Identity Pool ID
      const region = 'ap-south-1'; // e.g., 'us-east-1'
      const host = 'a1squtb7edv2t-ats.iot.ap-south-1.amazonaws.com'; // Replace with your IoT endpoint

      // Set AWS region
      AWS.config.region = region;

      // Fetch credentials
      const fetchCredentials = () => {
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: identityPoolId,
        });

        AWS.config.credentials.get(() => {
          setCredentials({
            accessKeyId: AWS.config.credentials.accessKeyId,
            secretAccessKey: AWS.config.credentials.secretAccessKey,
            sessionToken: AWS.config.credentials.sessionToken,
            host
          });
        });
      };

      fetchCredentials();
    } else if (!isSensorListening && mqttClient) {
      mqttClient.end();
      setMqttClient(null);
      setIsConnected(false);
      // isConnectedRef.current = false;
      console.log('Disconnected from AWS IoT -- ');
    }
  }, [isSensorListening]);


  useEffect(() => {

    if (credentials && isSensorListening && !isConnected && topic) {
      const { accessKeyId, secretAccessKey, sessionToken, host } = credentials;

      if (!accessKeyId || !secretAccessKey || !sessionToken || !host) {
        console.error('Invalid AWS credentials. Please check your configuration.');
        return;
      }

      const client = awsIot({
        region: AWS.config.region,
        host,
        clientId: `mqtt_${Math.random().toString(36).substr(2, 10)}`,
        protocol: 'wss',
        accessKeyId,
        secretKey: secretAccessKey,
        sessionToken,
      });

      client.on('connect', () => {
        console.log('Connected to AWS IoT');
        client.subscribe(topic);
        setIsConnected(true);
      });

      client.on('message', (payloadTopic, payload) => {
        // console.log(`Message received from topic : ${topic}:`, payload.toString());
        if (payload && onVoltageChange && payloadTopic === topic) {
          console.log('got data -- ');
          const data = JSON.parse(payload)
          console.log('Reading field -- ', dataField);
          const newVoltage = data && data.state && data.state.reported && data.state.reported[dataField] && Number(data.state.reported[dataField]) || 0
          onVoltageChange(newVoltage);
        }
      });

      client.on('close', () => {
        console.log('MQTT connection closed');
        // isConnectedRef.current = false;
      });

      client.on('reconnect', () => {
        console.log('Reconnecting to AWS IoT...');
      });

      client.on('error', (err) => {
        console.error('MQTT Client Error:', err);
        toggleReciveSensorData && toggleReciveSensorData('N')
      });

      setMqttClient(client);

      return () => {
        if (client && !isSensorListening && credentials) {
          client.end();
          console.log('Disconnected from AWS IoT');
          toggleReciveSensorData && toggleReciveSensorData('N')
          setMqttClient(null);
          setIsConnected(false);
        }
      };
    }

  }, [onVoltageChange, topic, isSensorListening, credentials]);

  useEffect(() => {
    return () => {
      console.log('Cleaning up WebSocket connection on component unmount... on unmount');
      if (mqttClient) {
        mqttClient.end(() => {
          console.log('Disconnected from AWS IoT - unmount');
        });
        setMqttClient(null);
        setIsConnected(false);
        toggleReciveSensorData && toggleReciveSensorData('N')
      }
    };
  }, [mqttClient])

  useEffect(() => {

    if (!isSensorListening) {
      if (mqttClient && isConnected) {
        console.log('Cleaning up WebSocket connection on component unmount... on stop');
        mqttClient.end(() => {
          console.log('Disconnected from AWS IoT - stop');
        });
        setMqttClient(null);
        setIsConnected(false);
        toggleReciveSensorData && toggleReciveSensorData('N')
      }
    }
  }, [isSensorListening])

  return null;
};

export default FuelSensorData;
